export default __webpack_public_path__ + "static/media/HP7.9e9efda1.jpg";